export const NavArrowDown = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M16 8L14.59 6.59L9 12.17V0H7V12.17L1.41 6.59L0 8L8 16L16 8Z' fill='inherit' />
  </svg>
);

export const NavArrowRight = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z' fill='inherit' />
  </svg>
);
